import MovieCard from '@/components/feature/MovieCard';
import type { Movie } from '@/mocks/movies';

interface LatestRailProps {
  items: Movie[];
}

export default function LatestRail({ items }: LatestRailProps) {
  return (
    <div className="flex gap-4 overflow-x-auto no-scrollbar pb-2 -mx-1 px-1">
      {items.map((movie) => (
        <MovieCard key={movie.id} movie={movie} className="w-[150px] sm:w-[170px] md:w-[190px] shrink-0" />
      ))}
    </div>
  );
}